import { GREY_100, RED_200 } from '@mnd-frontend/ui';
import styled from 'styled-components';
import { useInteractionContext } from '../../context';
import { useFilterActive } from '../../hooks/data';

const Rect = styled.rect`
  transition: fill 0.2s;
`;

const DayShades = ({ scaleX, scaleY, data }: any) => {
  const ticks = scaleX.ticks(scaleX.interval).slice(0, -1);
  const [x0, x1] = scaleX.range();
  const [y1, y0] = scaleY.range();

  const { hoveredTick } = useInteractionContext();

  const lightBackground = GREY_100;
  const highlight = RED_200;

  const selected = useFilterActive(data);
  const selectedDays = selected.map((d: any) => scaleX.interval.floor(d.date));

  return (
    <>
      <defs>
        <linearGradient id="hoverMarkerGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={lightBackground} stopOpacity={0} />
          <stop offset="50%" stopColor={lightBackground} stopOpacity={1} />
        </linearGradient>
      </defs>
      {ticks.map((d: any, i: any) => (
        <Rect
          fill={
            d - hoveredTick === 0 ||
            selectedDays.reduce((acc: any, s: any) => acc || d - s === 0, false)
              ? highlight
              : i % 2
                ? lightBackground
                : 'white'
          }
          key={d.toString()}
          y={y0}
          height={y1 - y0}
          x={scaleX(d)}
          width={(x1 - x0) / ticks.length}
        />
      ))}
    </>
  );
};

export default DayShades;
